import React from "react";
import styled from "styled-components";
import { SCREEN_SM } from "../theme";
import SpaceHolder from "../component/Space";
const SytledWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const StyledContentDiv = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 0;
  margin-left: 0;
  padding: 0 0 0 0;
  border-radius: 0;

  font-size: 44px;
  line-height: 50px;
  color: rgba(17, 17, 17, 0.8);

  font-weight: bold;

  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  @media (max-width: ${SCREEN_SM}) {
    width: 100%;
    padding: 0.2rem 0.2rem;
  }
`;

const StyledDetailDiv = styled.div`
  width: 100%;
  margin-top: 0;
  margin-left: 0;
  padding: 0 0 0 0;
  border-radius: 0;

  font-size: 16px;
  line-height: 30px;
  text-align: center;
  font-weight: normal;
  white-space: pre;
`;

export interface NotDataViewProps {
  title: string;
  subTitle: string;
  detail: string;
  url: string;
  urlText: string;
}

export const NotDataView: React.FC<NotDataViewProps> = ({
  title,
  subTitle,
  detail,
  url,
  urlText,
}) => {
  return (
    <SytledWrapper>
      <StyledContentDiv>
        <div>{title}</div>
        <h2 style={{ fontSize: "24px" }}>{subTitle}</h2>

        <StyledDetailDiv>{detail}</StyledDetailDiv>
        <SpaceHolder isVertical={true} value={"30px"}></SpaceHolder>

        <a className="btn" style={{ fontSize: "24px" }} href={url}>
          {urlText}
        </a>
      </StyledContentDiv>
    </SytledWrapper>
  );
};
